<template>
    <textarea
        type="text"
        class="totem-textarea"
        @input="handleInput"
        :disabled="disabled"
        :value="value"
        v-bind="$attrs"
        :placeholder="placeholder"
    >
    </textarea>
</template>

<script>
    export default {
        name: 'totem-textarea',
        props: {
            value: String,
            disabled: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        methods: {
            handleInput ($event) {
                this.$emit('input', $event.target.value)
            }
        }
    }
</script>

<style lang="scss">
    .totem-textarea {
        border: 1px solid $quill_gray;
        padding: 10px;
        width: 100%;
        background: $alabaster;
    }
</style>
